import { DateTime } from "luxon";

const getDateFromISOString = (dateLike: string | undefined) =>
  dateLike ? DateTime.fromISO(dateLike) : undefined;

const getCurrentQuarter = () => {
  const now = DateTime.now();
  const month = now.month;
  const quarter = Math.ceil(month / 3);
  return `Q${quarter} ${now.year.toString().slice(-2)}`;
};

export { getCurrentQuarter, getDateFromISOString };
